import React from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';
import Button from '../../Button/Button';
import { useTranslation } from '../../../hooks/useTranslation';
import styles from '../Calculator.module.css';
import type { SubmissionStatus } from '../types';

interface EmailFormProps {
    email: string;
    acceptTerms: boolean;
    submissionStatus: SubmissionStatus;
    onEmailChange: (value: string) => void;
    onTermsToggle: () => void;
    onSubmit: () => void;
}

const EmailForm: React.FC<EmailFormProps> = ({
    email,
    acceptTerms,
    submissionStatus,
    onEmailChange,
    onTermsToggle,
    onSubmit,
}) => {
    const { t } = useTranslation();

    return (
        <div className={styles.emailForm}>
            <h3>{t('calculator.contact.title')}</h3>
            <p>{t('calculator.contact.subtitle')}</p>
            <input
                type="email"
                placeholder={t('calculator.contact.email')}
                value={email}
                onChange={(e) => onEmailChange(e.target.value)}
                className={styles.emailInput}
            />
            <label className={`${styles.option} ${acceptTerms ? styles.selected : ''}`}>
                <input
                    type="checkbox"
                    checked={acceptTerms}
                    onChange={onTermsToggle}
                    className={styles.checkbox}
                />
                <span className={styles.checkmark}></span>
                {t('calculator.contact.terms')}
            </label>
            {submissionStatus.error && (
                <div className={styles.errorMessage}>{submissionStatus.error}</div>
            )}
            {submissionStatus.success && (
                <div className={styles.successMessage}>{t('calculator.success.message')}</div>
            )}
            <Button
                variant="primary"
                onClick={onSubmit}
                rightIcon={<MdKeyboardArrowRight size={24} />}
                className={styles.saveButton}
                disabled={!acceptTerms || submissionStatus.loading}
            >
                {submissionStatus.loading
                    ? t('calculator.submit') + '...'
                    : t('calculator.submit')}
            </Button>
        </div>
    );
};

export default EmailForm;
